import { WREG_ORDER, type WregStep } from '@/components/webreg/wregSteps';

export const WREG_ENTRY_PATH = '/';

export const WREG_ROUTE: Record<WregStep, string> = {
  intake: '/details',
  screener: '/health-check',
  tracks: '/programs',
  agreement: '/terms',
  switch: '/switch-consent',
  labs: '/lab-results',
  monitor: '/shipping',
  allset: '/all-set',
  'x-notelig': '/not-eligible',
  'x-already': '/already-enrolled',
  'x-control': '/control-group',
  'x-mismatch': '/confirm-details',
  'x-noqualify': '/no-qualifying-condition',
  'x-error': '/something-went-wrong',
  'x-switchok': '/switch-complete',
  'x-outreach': '/we-will-reach-out',
  'x-labspending': '/labs-pending',
  'x-declined': '/declined',
};

export const WREG_STEP_BY_ROUTE: Record<string, WregStep> = Object.fromEntries(
  WREG_ORDER.map((step) => [WREG_ROUTE[step], step]),
);

export const WREG_PATHS: readonly string[] = WREG_ORDER.map((step) => WREG_ROUTE[step]);

const normalizePath = (pathname: string): string => {
  const withoutQuery = pathname.split('?')[0].split('#')[0];
  if (withoutQuery.length > 1 && withoutQuery.endsWith('/')) return withoutQuery.replace(/\/+$/, '');
  return withoutQuery;
};

export const wregStepFromPath = (pathname: string): WregStep | null =>
  WREG_STEP_BY_ROUTE[normalizePath(pathname)] ?? null;

export const isWregPath = (pathname: string): boolean => wregStepFromPath(pathname) !== null;

// `promo` is carried like `invite` because a member bounced back to Landing mid-flow must re-enter
// through the same client, and because the promo code is now also the second condition on which CMS
// the eligibility and alignment calls reach (RND-38696).
export const WREG_CARRIED_PARAMS: readonly string[] = [
  'scenario',
  'disclosure',
  'cms',
  'invite',
  'promo',
];

export const WREG_ENTRY_PARAMS: readonly string[] = ['step', 'code'];

export const wregCarriedSearch = (search: string): string => {
  const source = new URLSearchParams(search);
  const carried = new URLSearchParams();
  for (const name of WREG_CARRIED_PARAMS) {
    const value = source.get(name);
    if (value !== null) carried.set(name, value);
  }
  const next = carried.toString();
  return next === '' ? '' : `?${next}`;
};

export const RETIRED_ROUTES: readonly string[] = [
  '/wreg-foundation',
  '/medicare-coverage',
  '/health-conditions',
  '/ckm-conditions',
  '/behavioral-health-conditions',
  '/phq9-screener',
  '/gad7-screener',
  '/eligibility-result',
  '/consent',
  '/create-account',
  '/download-app',
  '/check-sms',
];
